import React from 'react';
import { getUILoc } from '../../utils/cardUtils.js';

const YonotsuneNodeMap = ({ activeRun, onSelectNode, onAbandonRun, cardDefs, hideHUD }) => {
  return (
    <div className="node-selection-content" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {!hideHUD && (
        <div className="run-hud">
          {/* フォールバック用、基本は親で表示 */}
        </div>
      )}

      <div className="node-content">
        <h2 className="section-title">{getUILoc('YONOTSUNE.NODE_MAP_TITLE')}</h2>
        <div className="nodes-grid">
          {activeRun.currentNodes.map((node, i) => {
            const imageUrl = `/assets/nodes/node_${node.id}.png`;
            return (
              <div 
                key={i} 
                className={`proceeding-card type-${node.id}`} 
              >
                <div 
                  className="node-card-bg" 
                  style={{ backgroundImage: `url(${imageUrl})` }}
                ></div>
                <div className="node-glow"></div>
                <h3>{node.name}</h3>
                <p className="node-desc">{node.desc}</p>
                <button className="node-action-btn" onClick={() => onSelectNode(node.id)}>{getUILoc('YONOTSUNE.EVENTS.NEXT_NODE')}</button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default YonotsuneNodeMap;
